import {Model} from '../Models';
import {DataTransferObject} from './DataTransferObject';
import {PaymentInfoDTO} from './PaymentInfoDTO';

export class CreditCardDTO extends PaymentInfoDTO {
  cardHolder: string = '';
  cardNumber: string = '';
  expirationDate: string = '';
  cvcCvv: string = '';

  fromData(data: any): CreditCardDTO {
    const dto = new CreditCardDTO();
    dto.cardHolder = data.cardHolder;
    dto.cardNumber = data.cardNumber;
    dto.expirationDate = data.expirationDate;
    dto.cvcCvv = data.cvcCvv;
    return dto;
  }

  validate(): boolean {
    return this.validateField('cardHolder')
      && this.validateField('cardNumber')
      && this.validateField('expirationDate')
      && this.validateField('cvcCvv');
  }

  validateField(field: string): boolean {
    switch (field) {
      case 'cardHolder':
        return this.cardHolder !== undefined
          && this.cardHolder.match(/^([A-Za-zäöüÄÖÜß0-9\.'\s-]){3,128}$/) !== null;
      case 'cardNumber':
        return this.cardNumber.length === 16;
      case 'expirationDate':
        const expirationParts = this.expirationDate.split('/');
        return expirationParts.length === 2
          && expirationParts[0].length === 2
          && expirationParts[1].length === 2;
      case 'cvcCvv':
        return (this.cvcCvv.length === 3 || this.cvcCvv.length === 4);
      default:
        return false;
    }
  }

  fromModel(model: Model): DataTransferObject {
    throw new Error('Not implemented');
  }
}
